
import { Box3, BufferGeometry, Line, Line3, LineSegments, Material, Matrix4, Mesh, Object3D, Plane, Vector3 } from 'three';
import { CoordSys } from '../../hsbcad-model';

export class GeometryHelpers {

    static get SwitchHandnessMatrix() {
        return new Matrix4().set(1, 0, 0, 0,
            0, 0, 1, 0,
            0, -1, 0, 0,
            0, 0, 0, 1);

    }

    /**
     * Aligns given matrix4 to align with the given coordsys
     * @param matrix 
     * @param ptOrigFrom 
     * @param vecXFrom 
     * @param vecYFrom 
     * @param vecZFrom 
     * @param ptOrigTo 
     * @param vecXTo 
     * @param vecYTo 
     * @param vecZTo 
     */
    static setToAlignCoordSys(matrix: Matrix4, ptOrigFrom: Vector3, vecXFrom: Vector3, vecYFrom: Vector3, vecZFrom: Vector3, ptOrigTo: Vector3, vecXTo: Vector3, vecYTo: Vector3, vecZTo: Vector3): void {

        var matrixFrom = new Matrix4();
        matrixFrom.makeBasis(vecXFrom, vecYFrom, vecZFrom);
        matrixFrom.setPosition(ptOrigFrom);

        var matrixTo = new Matrix4();
        matrixTo.makeBasis(vecXTo, vecYTo, vecZTo);
        matrixTo.setPosition(ptOrigTo);

        matrix.copy(matrixFrom.multiply(matrixTo));
    };

    /**
     * Returns the coordsys of the given matrix4 as a CoordSys
     * @param matrix 
     * @returns The coordsys as a CoordSys
     */
    static getCoordSysMatrix(matrix: Matrix4) {
        var coordsys = new CoordSys();
        matrix.extractBasis(coordsys.vecX, coordsys.vecY, coordsys.vecZ);
        coordsys.ptOrg.setFromMatrixPosition(matrix);
        return coordsys;
    }

    static getCoordSysFromBuffer(coordsysbuf: number[]) {
        var coordsys = new CoordSys();

        coordsys.ptOrg.x = coordsysbuf[0]; coordsys.ptOrg.y = coordsysbuf[1]; coordsys.ptOrg.z = coordsysbuf[2];
        coordsys.vecX.x = coordsysbuf[3]; coordsys.vecX.y = coordsysbuf[4]; coordsys.vecX.z = coordsysbuf[5];
        coordsys.vecY.x = coordsysbuf[6]; coordsys.vecY.y = coordsysbuf[7]; coordsys.vecY.z = coordsysbuf[8];
        coordsys.vecZ.x = coordsysbuf[9]; coordsys.vecZ.y = coordsysbuf[10]; coordsys.vecZ.z = coordsysbuf[11];

        return coordsys;
    }

    /**
     * Sets the given matrix4 toi the given coordSys
     * @param matrix The matrix to adjust
     * @param coordsys The desired coordsys
     */
    static setFromCoordSys(matrix: Matrix4, coordsys: any): void {
        matrix.makeBasis(coordsys.vecX, coordsys.vecY, coordsys.vecZ);
        matrix.setPosition(coordsys.ptOrg);
    }

    /**
     * Returns matrix4 created from the given coordSys
     * @param coordsys 
     */
    static createFromCoordSys(coordsys: any): Matrix4 {
        var matrix = new Matrix4();
        matrix.makeBasis(coordsys.vecX, coordsys.vecY, coordsys.vecZ);
        matrix.setPosition(coordsys.ptOrg);
        return matrix;
    }


    /**
     * Creates a Box3 from a boxObject that contains a min and max vector3
     * @param boxObject 
     */
    static createBox(boxObject: { min: THREE.Vector3, max: THREE.Vector3 }): Box3 {
        let vecMin = new Vector3(boxObject.min.x, boxObject.min.y, boxObject.min.z);
        let vecMax = new Vector3(boxObject.max.x, boxObject.max.y, boxObject.max.z);
        return new Box3(vecMin, vecMax);
    }

    /**
     * Returns the normal for all combined vertices
     * @param vertices 
     */
    static NotNormalizedNormalFromVertices(vertices: THREE.Vector3[]) {
        let vN = new Vector3(); // default 0 vector
        // sum of cross products, assuming all vertices are in the same plane, also works for none convex polygons
        for (let i = 2; i < vertices.length; i++) {
            let j = (i - 1);
            let vi = vertices[i].clone().sub(vertices[0]);
            let vj = vertices[j].clone().sub(vertices[0]);
            let vec = new Vector3();
            vec.crossVectors(vi, vj);
            vN.add(vec);
        }
        return vN.normalize();
    }    
}





